import defineMessages from "../../../../../../common/helpers/defineMessages";

const messages = defineMessages({
    removeCard: {
        id: "tasks.rhythmSorting.removeCard",
    },
});

export default messages;
